var React = require('react');

function DotLine (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"dot-line-svg"),React.createElement("style",{"key":1},"\n\t\t.dot-line-s0 { fill: none;stroke: #d1c8ba;stroke-dasharray: 2 } \n\t"),React.createElement("path",{"id":"Layer","className":"dot-line-s0","d":"m0 0.5h209","key":2})]);
}

DotLine.defaultProps = {"version":"1.2","viewBox":"0 0 209 1","width":"209","height":"1"};

module.exports = DotLine;

DotLine.default = DotLine;
